import { render, staticRenderFns } from "./SystematicIntimidation.vue?vue&type=template&id=028955e9&"
import script from "./SystematicIntimidation.vue?vue&type=script&lang=js&"
export * from "./SystematicIntimidation.vue?vue&type=script&lang=js&"
import style0 from "./SystematicIntimidation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/user/workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('028955e9')) {
      api.createRecord('028955e9', component.options)
    } else {
      api.reload('028955e9', component.options)
    }
    module.hot.accept("./SystematicIntimidation.vue?vue&type=template&id=028955e9&", function () {
      api.rerender('028955e9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/people/legal_entities/tabs/SystematicIntimidation.vue"
export default component.exports